export default __webpack_public_path__ + "static/media/ball.c0e449d4.png";